import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { LogoutButtonContent } from "./account_area.style";
import { useTranslation } from "react-i18next";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "shared/provider/auth_provider";
import { NameClaim } from "models/authentication";

const AccountAreaComponent = () => {
  const { t } = useTranslation();
  const { authData, signOut } = useAuth();
  const humanName = authData.claims.find((cla) => cla.type == NameClaim);

  return (
    <Stack direction="row" alignItems="flex-end">
      <Stack direction="row" sx={{ mr: 2.5 }}>
        <Stack>
          <div>{humanName ? humanName.value : ""}</div>
          <Typography variant="caption">{authData.name}</Typography>
        </Stack>
      </Stack>
      <Button
        variant="outlined"
        onClick={() =>
          signOut(`${window.location.pathname}${window.location.search ?? ""}`)
        }
      >
        <LogoutButtonContent>
          <LogoutIcon /> {t("AccountAreaButtonLogout")}
        </LogoutButtonContent>
      </Button>
    </Stack>
  );
};

export default AccountAreaComponent;
